module.exports = __webpack_public_path__ + "img/katarina_kitchen_10.2dc84e96.jpg";